import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

// Loading Indicator with transparent background
const LoadingOverlay = ({ message }) => (
	<Box
		sx={{
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			backgroundColor: "rgba(255, 255, 255, 0.7)",
			zIndex: 1300,
			backdropFilter: "blur(3px)",
		}}>
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 2,
				maxWidth: 320,
				px: 2,
				textAlign: "center",
			}}>
			<CircularProgress variant="indeterminate" sx={{ color: "#000" }} size={60} />
			<Typography sx={{ color: "#000", fontWeight: 500 }}>{message}</Typography>
		</Box>
	</Box>
);

export default LoadingOverlay;
